import React from "react";

import BasePadding from "@cayuse/shared-react.components.base-padding";
import SectionHeader from "@cayuse/shared-react.components.section-header";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";

import ResolutionsList from "components/ResolutionsList";
import { useDictionary, useResolutions } from "hooks";

import styles from "./styles.css";


const ResolutionsMainView = () => {
	const dictionary = useDictionary("resolutions");
	const proposalResolutions = useResolutions("PROPOSAL");
	const projectResolutions = useResolutions("PROJECT");
	const awardResolutions = useResolutions("AWARD");
	const subawardResolutions = useResolutions("SUBAWARD");
	const awardDictionary = useDictionary("resolutions.award");
	const subawardDictionary = useDictionary("resolutions.subaward");
	const proposalDictionary = useDictionary("resolutions.proposal");
	const projectDictionary = useDictionary("resolutions.project");

	return (
		<div id={styles.resolutions}>
			<SectionHeader header={dictionary.manageResolutions} />
			<VerticalSpacing>
				<BasePadding>
					<ResolutionsList
						instanceResolutions={proposalResolutions}
						instanceDictionary={proposalDictionary}
						instance ={"PROPOSAL"}
					/>
				</BasePadding>
			</VerticalSpacing>
			<VerticalSpacing>
				<BasePadding>
					<ResolutionsList
						instanceResolutions={awardResolutions}
						instanceDictionary={awardDictionary}
						instance = {"AWARD"}
					/>
				</BasePadding>
			</VerticalSpacing>
			<VerticalSpacing>
				<BasePadding>
					<ResolutionsList
						instanceResolutions={subawardResolutions}
						instanceDictionary={subawardDictionary}
						instance = {"SUBAWARD"}
					/>
				</BasePadding>
			</VerticalSpacing>
			<VerticalSpacing>
				<BasePadding>
					<ResolutionsList
						instanceResolutions={projectResolutions}
						instanceDictionary={projectDictionary}
						instance = {"PROJECT"}
					/>
				</BasePadding>
			</VerticalSpacing>
		</div>
	);
};

export default ResolutionsMainView;
